export default __webpack_public_path__ + "static/media/Frame 758532294.792bed0a.svg";